<template>
  <div id="mainBitfinex">
    <table class="type2">
      <thead slot="head">
        <th>
          <input
            type="url"
            v-model="searching"
            v-on:input="fnSearch"
            size="2"
            style="text-transform: uppercase;"
          />
        </th>
        <th style="cursor:pointer; width: 4.8rem;">BITFINEX</th>
        <th style="cursor:pointer; width: 4.8rem;">업비트</th>
        <th style="cursor:pointer; width: 4.8rem;">빗썸</th>
        <th style="cursor:pointer; width: 4.8rem;">코인원</th>
      </thead>
      <tbody slot="body">
        <tr
          v-for="row in values"
          :key="row.id"
          @click.prevent="
            onClickModalView(row.title, row.market, row.retPriceSort, row.priceUpbitModal, row.priceBithumbModal, row.priceCoinoneModal)
          "
          style="cursor:pointer;"
        >
          <td class="text-center">
            <div style="padding-bottom:3px;">{{ row.market }}</div>
            <span v-html="row.marketPer"></span>
          </td>
          <td class="num tah">
            <span v-html="row.priceBitfinex"></span>
            <br />
            <span v-html="row.priceBitfinexKrw"></span>
          </td>
          <td class="num tah">
            <span v-html="row.priceUpbitKrw"></span>
            <br />
            <span v-html="row.priceUpbitPer"></span>
          </td>
          <td class="num tah">
            <span v-html="row.priceBithumbKrw"></span>
            <br />
            <span v-html="row.priceBithumbPer"></span>
          </td>
          <td class="num tah">
            <span v-html="row.priceCoinoneKrw"></span>
            <br />
            <span v-html="row.priceCoinonePer"></span>
          </td>
        </tr>
      </tbody>
    </table>
    <modalview
      v-if="isModalView"
      @close="isModalView = false"
      :coinSite="coinSite"
      :coinName="coinName"
      :coinPrice="coinPrice"
      :coinPriceUpbit="coinPriceUpbit"
      :coinPriceBithumb="coinPriceBithumb"
      :coinPriceCoinone="coinPriceCoinone"
    />
  </div>
</template>

<script>
import modalview from './modal_view.vue'
export default {
  name: 'mainBitfinex',
  components: { modalview },
  data () {
    return {
      values: [],
      searching: '',
      isModalView: false,
      coinSite: {},
      coinName: {},
      coinPrice: {},
      coinPriceUpbit: {},
      coinPriceBithumb: {},
      coinPriceCoinone: {}
    }
  },
  methods: {
    fetchData: function (coinName) {
      this.$axios
        .get('https://wisebody.co.kr/api/getBitfinex.php', {
          params: {
            coinName: coinName
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$root.$refs.H.lastUpdateDate = res.data.WDATE
            this.$root.$refs.MENU.TCAP = res.data.TCAP
            this.$root.$refs.MENU.TPER = res.data.TPER
            this.$root.$refs.MENU.TBTC = res.data.TBTC
            this.$root.$refs.MENU.TBTCPER = res.data.TBTCPER
            this.$root.$refs.MENU.usd_naver_top = res.data.AUSD_TOP
            this.$root.$refs.F.usd_naver = res.data.AUSD
            this.$root.$refs.F.usdt = res.data.AUSDT
            if (res.data.TOTAL === 0) {
              this.values = []
            } else {
              this.values = res.data.list
            }
          } else {
            console.log('Server Error')
          }
        })
        .catch(e => {
          console.error(e.message)
        })
    },
    onClickModalView: function (coinSite, coinName, coinPrice, coinPriceUpbit, coinPriceBithumb, coinPriceCoinone) {
      this.coinSite = coinSite
      this.coinName = coinName
      this.coinPrice = coinPrice
      this.coinPriceUpbit = coinPriceUpbit
      this.coinPriceBithumb = coinPriceBithumb
      this.coinPriceCoinone = coinPriceCoinone
      this.isModalView = true
    },
    fnSearch: function (e) {
      this.fetchData(e.target.value.toUpperCase())
    }
  },
  created () {
    this.$root.$refs.M = this
    this.fetchData()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/bitfinex.vue